<template>
  <div class="product-auction padding-bottom">
    <div class="container">
      <div class="row mb-5">
        <div class="col-lg-12 mt-2">
          <div class="row mb-2">
            <div class="col-12 col-lg-6">
              <h2 class="title mb-5 mb-lg-0 title-lotes-disponiveis">Lotes Disponíveis</h2>
            </div>
            <div class="col-12 col-lg-6 d-flex justify-content-center align-items-start flex-wrap flex-lg-nowrap">
              <div class="combo mr-lg-4 mb-4" @click="classificacaoShow = !classificacaoShow" @focusout="handleFocusOut" tabindex="0">
                <div class="select-numero-lote">
                  {{ classificacaoText }}
                </div>
                <ul :class="{ active: classificacaoShow }">
                  <li @click="classificar('')" :class="{ active: classificacao == '' }">
                    <input type="radio" name="classificacao" class="form-filtrar" value="" v-model="classificacao" />Número do Lote
                  </li>
                  <li v-for="item in getOrdens" :key="item.titulo" @click="classificar(item.ordem)" :class="{ active: classificacao == item.ordem }">
                    <input type="radio" name="classificacao" class="form-filtrar" :value="item.ordem" v-model="classificacao" />
                    {{ item.descricao }}
                  </li>
                </ul>
              </div>
              <div class="combo mb-4" v-if="getCategoria" @click="filtrarShow = !filtrarShow" @focusout="handleFocusOut" tabindex="0">
                <div class="select-numero-lote select-filtrar">
                  FILTRAR
                  <span class="badge badge-warning ml-2 p-1" v-if="qtdFiltro > 0">{{ qtdFiltro }}</span>
                </div>
                <ul :class="{ active: filtrarShow }" class="ul-filtrar">
                  <li
                    v-for="sub in getCategoria.subcategorias"
                    :key="sub.categoriaId"
                    @click="filtrarCategoria(sub.categoriaId)"
                    :class="{ active: categoria == sub.categoriaId }"
                  >
                    <input type="radio" name="filtrar" class="form-filtrar" :value="sub.categoriaId" v-model="categoria" />
                    {{ sub.descricao }}
                  </li>
                  <li @click="filtrarEncerrados()" class="item-encerrados">
                    <input type="checkbox" name="encerrados" class="form-filtrar" v-model="removerEncerrados" />
                    Somente Lotes Abertos
                  </li>
                  <li class="text-center text-danger mt-3" @click="limparFiltro()">LIMPAR</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row" v-if="!getLotesLoading">
            <div class="col-6 mb-3">
              <p class="m-0">
                Itens por página:
                <select class="select-item-pagina m-0" v-model="pageSize" @change="setLotesPorPagina()">
                  <option value="6">6</option>
                  <option value="12">12</option>
                  <option value="24">24</option>
                  <option value="32">32</option>
                  <option value="38">38</option>
                </select>
              </p>
            </div>
            <div class="col-6 text-right mb-3">
              <p class="m-0">{{ getTotalLotes }} Lotes Encontrados</p>
            </div>
          </div>
          <div class="row mb-30-none justify-content-center">
            <lote-card-vertical
              v-for="lote in getLotesPorLeilao"
              :key="lote.id"
              :lote="lote"
              classeRaiz="col-lg-6 col-md-12 col-sm-12 justify-content-center"
            />
            <div class="col-12 text-center m-5" v-if="!getLotesLoading && getLotesPorLeilao && getLotesPorLeilao.length == 0">
              <h6 class="text-muted">NENHUM LOTE ENCONTRADO COM O FILTRO SELECIONADO</h6>
            </div>
            <h4 class="title mb-5 mt-5 verTodos" v-if="getLotesLoading">CARREGANDO...</h4>
          </div>
          <pagination-numeric
            v-if="!getLotesLoading && totalPages > 1"
            :total-items="getTotalLotes"
            :page-size="getLotesPorPagina"
            :current-page="pageNumber"
            @change="onPageChange"
            aria-label="Paginação de lotes"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoteCardVertical from '@/components/LoteCardVertical.vue';
import PaginationNumeric from '@/components/PaginationNumeric.vue';
// import LoteCardLoader from '@/components/LoteCardLoader.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  props: {
    leilaoId: String,
  },
  data() {
    return {
      classificacaoShow: false,
      classificacaoText: 'CLASSIFICAR POR',
      filtrarShow: false,
      filtro: '',
      classificacao: '',
      removerEncerrados: false,
      categoria: 0,
      categorias: [],
      qtdFiltro: 0,
      pageNumber: 0,
      pageSize: 6,
    };
  },
  components: {
    LoteCardVertical,
    PaginationNumeric,
    // LoteCardLoader,
  },
  watch: {
    pageNumber(value, oldvalue) {
      if (value == oldvalue) return;

      this.getPagina(this.pageNumber);
    },
    '$route.query.page'(newVal) {
      const p = parseInt(newVal);
      const page = !isNaN(p) && p > 0 ? p : 1;
      if (page !== this.pageNumber) {
        // Atualiza página sem reescrever a URL (evita loop)
        this.pageNumber = page;
      }
    },
    '$route.query.size'(newVal) {
      const s = parseInt(newVal);
      if (!isNaN(s) && s > 0 && s !== (this.getLotesPorPagina || this.pageSize)) {
        // Atualiza tamanho via store e refaz filtro inicial, sem atualizar a URL aqui
        this.pageSize = s;
        this.SET_LOTES_POR_PAGINA(s);
        this.filtrarLotes();
      }
    },
    '$route.query.ordem'(newVal) {
      const ordem = typeof newVal === 'string' ? newVal : '';
      if (ordem !== this.classificacao) {
        this.classificacao = ordem;
        this.filtrarLotes();
      }
    },
    '$route.query.categoria'(newVal) {
      const cid = parseInt(newVal);
      const categoriaId = !isNaN(cid) && cid > 0 ? cid : 0;
      if (categoriaId !== this.categoria) {
        this.categoria = categoriaId;
        this.categorias = categoriaId ? [categoriaId] : [];
        // Ajusta contador de filtros
        this.qtdFiltro = (this.categoria ? 1 : 0) + (this.removerEncerrados ? 1 : 0);
        this.filtrarLotes();
      }
    },
    '$route.query.removerEncerrados'(newVal) {
      const val = String(newVal).toLowerCase();
      const parsed = val === 'true' || val === '1';
      if (parsed !== this.removerEncerrados) {
        const prev = this.removerEncerrados;
        this.removerEncerrados = parsed;
        // Ajusta contador de filtros
        if (parsed && !prev) this.qtdFiltro++;
        if (!parsed && prev) this.qtdFiltro--;
        this.filtrarLotes();
      }
    },
  },
  computed: {
    ...mapGetters([
      'getOrdens',
      'getLotesPorLeilao',
      'getLotesLoading',
      'getCategorias',
      'getLeilao',
      'getIsNextPageLote',
      'getTotalLotes',
      'getLotesPorPagina',
    ]),
    getCategoria() {
      const leilao = this.getLeilao;
      const categorias = this.getCategorias.find((x) => x.descricao == leilao.categoria);
      return categorias;
    },
    totalPages() {
      const size = this.getLotesPorPagina || this.pageSize || 6;
      const total = Math.ceil((this.getTotalLotes || 0) / size);
      return Math.max(1, total);
    },
  },
  methods: {
    ...mapActions(['setLotesPorLeilao']),
    ...mapMutations(['SET_LOTES_POR_LEILAO', 'IS_NEXT_PAGE_LOTE', 'SET_LOTES_POR_PAGINA']),
    carregarMaisLeiloes() {
      // Compatível, porém substituído pela paginação numérica
      this.onPageChange(this.pageNumber + 1);
    },
    onPageChange(page) {
      // Resetar lista para não acumular itens de páginas anteriores
      this.SET_LOTES_POR_LEILAO();
      this.pageNumber = page;
      // watcher(pageNumber) acionará getPagina
      this.updateRouteQuery();
      this.scrollToTop();
    },
    setLotesPorPagina() {
      this.SET_LOTES_POR_PAGINA(this.pageSize);
      this.filtrarLotes();
      this.updateRouteQuery();
      this.scrollToTop();
    },
    filtrarLotes() {
      this.SET_LOTES_POR_LEILAO();
      this.pageNumber = 1;
      this.filtro = {
        ordem: this.classificacao,
        categorias: this.categorias,
        removerEncerrados: this.removerEncerrados,
      };
      this.atualizaLotes({
        pageNumber: 1,
        pageSize: this.getLotesPorPagina,
        categorias: this.filtro.categorias,
        ordem: this.filtro.ordem || '',
        removerEncerrados: this.filtro.removerEncerrados || false,
      });
      this.updateRouteQuery();
      this.scrollToTop();
    },
    getPagina(pageNumber) {
      // Garantir que não haja append de páginas anteriores
      this.SET_LOTES_POR_LEILAO();
      this.atualizaLotes({
        pageNumber: pageNumber,
        pageSize: this.getLotesPorPagina,
        categorias: this.filtro.categorias,
        ordem: this.filtro.ordem || '',
        removerEncerrados: this.filtro.removerEncerrados || false,
      });
    },
    classificar(ordem) {
      this.classificacao = ordem;
      this.filtrarLotes();
    },
    filtrarCategoria(categoriaId) {
      if (this.categoria == 0) this.qtdFiltro++;
      this.categoria = categoriaId;
      this.categorias = [categoriaId];
      this.filtrarLotes();
    },
    filtrarEncerrados() {
      this.removerEncerrados = !this.removerEncerrados;
      this.removerEncerrados ? this.qtdFiltro++ : this.qtdFiltro--;
      this.filtrarLotes();
    },
    limparFiltro() {
      this.qtdFiltro = 0;
      this.categoria = 0;
      this.categorias = [];
      this.removerEncerrados = false;
      this.filtrarLotes();
    },
    handleFocusOut() {
      this.filtrarShow = false;
      this.classificacaoShow = false;
    },
    atualizaLotes(payload) {
      this.setLotesPorLeilao({
        leilaoId: this.leilaoId,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize || 6,
        categorias: payload.categorias || '',
        ordem: payload.ordem || '',
        removerEncerrados: payload.removerEncerrados || false,
      });
    },
    updateRouteQuery() {
      // Mantém outros parâmetros e sincroniza page/size/filtros na URL
      const size = this.getLotesPorPagina || this.pageSize || 6;
      const desired = {
        ...this.$route.query,
        page: String(this.pageNumber || 1),
        size: String(size),
        ordem: this.classificacao || '',
        categoria: this.categoria ? String(this.categoria) : '',
        removerEncerrados: this.removerEncerrados ? 'true' : 'false',
      };
      // Remover chaves vazias para manter URL limpa
      if (!desired.ordem) delete desired.ordem;
      if (!desired.categoria) delete desired.categoria;
      const keys = ['page', 'size', 'ordem', 'categoria', 'removerEncerrados'];
      const unchanged = keys.every((k) => (this.$route.query[k] || '') === (desired[k] || ''));
      if (!unchanged) {
        this.$router.replace({ path: this.$route.path, query: desired });
      }
    },
    scrollToTop() {
      try {
        const el = document.querySelector('.title-lotes-disponiveis');
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (e) {
        // fallback sem smooth, garantindo visibilidade da seção
        const el = document.querySelector('.title-lotes-disponiveis');
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          window.scrollTo(0, top);
        } else {
          window.scrollTo(0, 0);
        }
      }
    },
  },
  async created() {
    // Inicializa página/tamanho a partir da URL, com defaults
    const qp = parseInt(this.$route.query.page);
    const qs = parseInt(this.$route.query.size);
    if (!isNaN(qs) && qs > 0) {
      this.pageSize = qs;
      this.SET_LOTES_POR_PAGINA(qs);
    }
    // Inicializar filtros a partir da URL
    const ordem = typeof this.$route.query.ordem === 'string' ? this.$route.query.ordem : '';
    this.classificacao = ordem;
    const catParsed = parseInt(this.$route.query.categoria);
    const categoriaId = !isNaN(catParsed) && catParsed > 0 ? catParsed : 0;
    this.categoria = categoriaId;
    this.categorias = categoriaId ? [categoriaId] : [];
    const rem = this.$route.query.removerEncerrados;
    const removerEnc = String(rem).toLowerCase() === 'true' || String(rem) === '1';
    this.removerEncerrados = removerEnc;
    this.qtdFiltro = (this.categoria ? 1 : 0) + (this.removerEncerrados ? 1 : 0);
    // Garantir filtro atualizado antes de paginar
    this.filtro = { categorias: this.categorias, ordem: this.classificacao, removerEncerrados: this.removerEncerrados };
    const initialPage = !isNaN(qp) && qp > 0 ? qp : 1;
    this.pageNumber = initialPage; // Dispara watcher para carregar a página com filtro
    this.$nextTick(() => this.updateRouteQuery());
  },
  destroyed() {
    this.SET_LOTES_POR_LEILAO();
    this.IS_NEXT_PAGE_LOTE();
  },
};
</script>

<style scoped>
button {
  border-radius: 13px;
}

.select-item-pagina {
  width: auto;
  border-radius: 19px;
  padding: 0;
  margin: 0 10px;
  text-align: center;
  border: none;
  color: #171d1c;
  font-size: 14px;
  font-weight: 600;
  height: 25px;
}

.combo {
  position: relative;
  width: 100%;
  height: 35px;
}
.select-numero-lote {
  font-weight: 800;
  color: #52606d;
  border-radius: 25px;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.4);
  height: 35px;
  border: none;
  background: #f7f7f7;
  background-image: url(/assets/images/chevrons-down.png);
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 6px;
  width: 100%;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  position: absolute;
  top: 0;
  z-index: 9;
  font-size: 0.9em;
}

.combo ul {
  position: absolute;
  top: 0;
  padding: 45px 0 10px;
  border-radius: 20px;
  background-color: #fff;
  z-index: 8;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.4);
  width: 100%;
  text-align: left;
  display: none;
}

.combo ul.active {
  display: block;
  -webkit-animation: fadeIn 500ms;
  animation: fadeIn 500ms;
}

.combo ul li {
  color: #52606d;
  padding: 2px 15px;
  display: block;
  font-size: 16px;
  font-weight: 500;
}

.combo ul li:hover,
.combo ul li.active {
  background-color: #d9d9d973;
  cursor: pointer;
}

.combo label {
  margin: 0;
  padding: 0;
}

.select-filtrar {
  z-index: 7 !important;
}

.ul-filtrar {
  z-index: 6 !important;
}

.item-encerrados {
  margin-top: 20px;
  padding: 15px 0 15px 15px !important;
  border-top: 1px solid #ddd;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.verTodos {
  color: #0b184a;
  cursor: pointer;
}

.form-filtrar {
  display: inline;
  width: 12px;
  height: 12px;
  margin-right: 15px;
}
@media (max-width: 1199px) {
  .title-lotes-disponiveis {
    text-align: center;
  }
}
</style>
